import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { faSparkles } from '@fortawesome/pro-solid-svg-icons';
import { ButtonComponent, TooltipDirective } from '@pure/hive';

import { trackQuestionClicked } from '../copilot-question-analytics';

/**
 * One suggested follow-up question, rendered under a Copilot answer in the side panel.
 *
 * The full-page Copilot view renders its follow-ups as the outlined
 * `copilot-follow-up-bubble`; the panel uses this accent "ai chip" instead, matching the
 * side-panel mock and the "Try asking:" pills it sits beside.
 */
@Component({
    selector: 'copilot-follow-up-chip',
    templateUrl: './follow-up-chip.component.html',
    styleUrls: ['./follow-up-chip.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    preserveWhitespaces: false,
    imports: [ButtonComponent, TooltipDirective],
})
export class FollowUpChipComponent {
    readonly text = input.required<string>();
    readonly selectQuestion = output<string>();

    protected readonly faSparkles = faSparkles;

    protected onClick(): void {
        const question = this.text();
        trackQuestionClicked(question, 'follow up');
        this.selectQuestion.emit(question);
    }
}
